<template>


    <div class="tw-bg-blue-light">
        <v-form
                class="tw-py-12 tw-flex tw-flex-col tw-gap-24 limiter formulaire-event"
                ref="form"
                v-model="valid"
                lazy-validation
        >

            <h4 class="tw-text-5xl">
                Informations principales
            </h4>

            <div class="tw-grid tw-gap-8 md:tw-grid-cols-2">

                <v-text-field
                        v-model="titre"
                        :counter="50"
                        :rules="nameRules"
                        label="Titre*"
                        prepend-icon="mdi-format-title"

                ></v-text-field>

                <v-text-field
                        v-model="organisateurs"
                        :counter="200"
                        :rules="lengthRules"
                        label="Organisateurs*"
                        prepend-icon="mdi-account"
                ></v-text-field>

                <v-text-field
                        v-model="collaboration"
                        :counter="200"
                        label="En collaboration avec"
                        prepend-icon="mdi-handshake"

                ></v-text-field>

                <div>
                    <v-select
                            v-if="regionsItems"
                            v-model="region"
                            :items="regionsItems"
                            :rules="requiredRules"
                            label="Région*"
                            return-object
                            prepend-icon="mdi-map"
                    >
                    </v-select>
                    <span class="text-1-5">
               Il s’agit ici de la région où se déroule l’événement.
          </span>
                </div>




            </div>

            <div>
                <h4 class="tw-mb-12 tw-text-5xl">
                    Infos Pratiques
                </h4>
                <div class="tw-flex tw-flex-col tw-gap-8 tw-mb-8">
                    <div v-for="(date,index) in dates" :key="date.id" class="tw-pb-4 tw-grid tw-gap-x-8 md:tw-grid-cols-3 border-bottom">

                        <v-menu
                                v-model="menuDate[index]"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                        :value="affichageDate(date.date_debut)"
                                        label="Date de l'événement*"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="changeDatePicker"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="date.date_debut"
                                           locale="fr-FR"
                                           :first-day-of-week="1"
                                           selectedItemsText="{0} sélectionnés"
                                           min="2024-03-20"
                                           max="2024-04-08"
                                           :rules="requiredRules"
                                           range
                                           :picker-date="datePicker"
                            >
                            </v-date-picker>
                        </v-menu>

                        <v-text-field
                                v-model="date.heure"
                                prepend-icon="mdi-clock"
                                label="Heure de début*"
                                :rules="requiredRules"
                                type="time"

                        ></v-text-field>

                        <v-text-field
                                v-model="date.lieu"
                                :rules="requiredRules"
                                prepend-icon="mdi-home-city"
                                label="Lieu*"

                        ></v-text-field>

                        <v-text-field
                                v-model="date.ville"
                                :rules="requiredRules"
                                prepend-icon="mdi-city"
                                label="Ville*"
                        ></v-text-field>

                        <v-text-field
                                v-model="date.code_postal"
                                :rules="requiredRules"
                                prepend-icon="mdi-numeric"
                                label="Code postal*"

                        ></v-text-field>

                        <v-text-field
                                v-model="date.adresse"
                                :rules="requiredRules"
                                prepend-icon="mdi-map-marker"
                                label="Adresse*"

                        ></v-text-field>

                        <v-text-field
                                v-model="date.lien_plus_dinfos"
                                :rules="checkUrlField(date.lien_plus_dinfos)"
                                placeholder="https://exemple.com"
                                prepend-icon="mdi-link-variant"
                                label="Lien plus d'infos"

                        ></v-text-field>

                    </div>
                    <div>
                        <v-btn color="primary" @click="addDate"><v-icon left>mdi-plus</v-icon>Ajouter une date</v-btn>
                        <v-btn class="tw-ml-8" v-if="dates.length > 1" color="secondary" @click="removeDate"><v-icon left>mdi-minus</v-icon>Retirer une date</v-btn>
                    </div>
                </div>

                <v-text-field
                        v-model="publicEvent"
                        :rules="requiredRules"
                        prepend-icon="mdi-account-group"
                        label="Public*"
                ></v-text-field>

            </div>

            <h4 class="tw-text-5xl">
                Votre événement
            </h4>

            <div>
                <div class="tw-text-4xl tw-mb-4">Image principale*</div>
                <VueFileAgent v-model="imagePrincipale" :multiple="false" :maxSize="'10MB'" :helpText="'Déposez votre image ici'" :accept="'image/*'"></VueFileAgent>
                <span class="text-1-5">
            Pour un meilleur rendu , privilégiez les images de 800px de large minimum, en format paysage
          </span>
            </div>

            <div>
                <v-select
                        v-model="reglesDuJeu"
                        :items="regles"
                        :rules="reglesRules"
                        prepend-icon="mdi-book-open"
                        label="Règles du jeu choisies*"
                        :multiple="true"
                >
                </v-select>
                <span class="text-1-5">
            L’Enfance des arts s’appuie sur 7 contraintes créatives, pensées pour nourrir votre réflexion et vous inciter à sortir du cadre. Pour participer, vous devez en choisir au moins 3, dont le mélange des disciplines (la valorisation de la pluridisciplinarité de la création jeune public étant au coeur de l'Enfance des arts). Pour en savoir plus sur chacune de ces contraintes créatives, cliquez <a class="lien-hint" href="/les-regles-du-jeu" target="_blank">ICI</a>.
          </span>
            </div>

            <div>
                <v-checkbox
                        v-model="olympiade_culturelle"
                        label="Je souhaite inscrire mon événement dans le cadre de l’Olympiade Culturelle (facultatif)"
                ></v-checkbox>
                <span class="text-1-5">Pour rappel, vous devez impérativement vous inscrire sur le site de l’Olympiade Culturelle pour bénéficier de la double appellation. Cliquez <a class="lien-hint" href="/olympiade-culturelle" target="_blank">ICI</a> pour en savoir plus.</span>
            </div>

            <div>
                <v-textarea
                        name="input-7-4"
                        label="Disciplines croisées*"
                        v-model="investigation"
                        :counter="500"
                        :rules="textareaRules"
                        auto-grow
                        rows="3"
                        row-height="30"
                        shaped
                        filled
                ></v-textarea>
                <span class="text-1-5">L’Enfance des arts est une célébration de la multidisciplinarité et de l’innovation dans  la création jeune public. Précisez ici quel croisement de disciplines ou quel mélange  de pratiques artistiques et non artistiques vous avez choisi d’expérimenter  (exemple : danse et cuisine, théâtre et botanique, musique et marionnette...)</span>
            </div>

            <div>
                <v-textarea
                        name="input-7-4"
                        label="Description de l’événement*"
                        v-model="aPropos"
                        auto-grow
                        :counter="1200"
                        rows="3"
                        row-height="30"
                        :rules="aProposRules"
                        shaped
                        filled
                ></v-textarea>
                <span class="text-1-5">
Décrivez votre événement : en quoi consiste-t-il ? Comment s'inspire-t-il des règles du jeu ? Quelle place y est accordée aux enfants et aux artistes (précisez le nom des artistes concerné·es le cas échéant). Si votre événement s’inscrit dans l’Olympiade Culturelle, expliquez le lien avec le sport et/ou les valeurs olympiques (inclusion, diversité culturelle, amitié, partage…).
        </span>
            </div>

            <div>
                <div class="tw-text-4xl tw-mb-4">Galerie Photo</div>
                <VueFileAgent ref="galerie" @beforedelete="fileDeleted($event)" v-model="galerieRecords" :multiple="true" :helpText="'Déposez vos images ici'" :maxSize="'10MB'" :deletable="true" :accept="'image/*'"></VueFileAgent>
                <span class="text-1-5">
            Pour un meilleur rendu , privilégiez les images de 800px de large minimum
          </span>
            </div>

            <div>
                <v-text-field
                        v-model="video"
                        prepend-icon="mdi-youtube"
                        label="URL Vidéo"
                ></v-text-field>
                <span class="text-1-5">Vidéos hébergées sur Youtube ou Viméo uniquement</span>
            </div>


            <v-textarea
                    name="input-7-4"
                    :rules="demarchesRules"
                    label="Comment ce projet s'inscrit-il dans votre démarche générale ?"
                    :counter="800"
                    v-model="projet"
                    auto-grow
                    rows="3"
                    row-height="30"
                    shaped
                    filled
            ></v-textarea>

            <div class="tw-grid tw-gap-8 md:tw-grid-cols-2">
                <div>
                    <v-text-field
                            required
                            v-model="contact"
                            prepend-icon="mdi-account-box"
                            label="Contact de l'organisateur*"
                            type="email"
                            :rules="emailRules"
                    ></v-text-field>
                    <span class="text-1-5">
            Précisez ici l’adresse mail que vous souhaitez voir apparaître sur le site
          </span>
                </div>

                <div>
                    <v-text-field
                            v-model="siteOrganisateur"
                            :rules="checkUrlField(siteOrganisateur)"
                            placeholder="https://exemple.com"
                            prepend-icon="mdi-link-variant"
                            label="Site de l'organisateur"
                    ></v-text-field>
                    <span class="text-1-5">
            Précisez ici le lien vers le site internet de l'organisateur
          </span>
                </div>
            </div>

            <div class="tw-w-full tw-mt-12 tw-flex tw-flex-col md:tw-flex-row tw-gap-12 tw-items-start md:tw-items-center">
                <v-btn
                        color="primary"
                        @click="validate"
                >
                    Envoyer pour validation
                </v-btn>

                <div v-if="!valid">
                    <span class="text-1-5"><v-icon color="primary" left>mdi-alert-circle-outline</v-icon>Des champs ont mal été renseignés</span>
                </div>

                <div class="tw-w-full tw-items-center tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-gap-8" v-if="sending">
                    <v-progress-linear
                            class="tw-w-96"
                            color="primary accent-4"
                            :value="progressValue"
                            rounded
                            height="6"
                            :indeterminate="progressValue === 100"
                    ></v-progress-linear>
                    <span v-if="progressValue !== 100" class="tw-block text-1-5">Envoi de vos photos</span>
                    <span class="tw-block text-1-5" v-else>Envoi de votre participation</span>

                </div>

                <div v-if="emptyImage">
                    <span class="text-1-5"><v-icon color="primary" left>mdi-alert-circle-outline</v-icon>L'image principale n'est pas renseignée</span>
                </div>

                <div v-if="maxSizeFileError">
                    <span class="text-1-5"><v-icon color="primary" left>mdi-alert-circle-outline</v-icon>Le poids d'une ou plusieurs images dépassent la limite d'envoi</span>
                </div>

                <div v-if="sent">
                    <span class="text-1-5"><v-icon color="primary" left>mdi-check</v-icon>Votre participation a été envoyée avec succès</span>
                </div>

                <div v-else-if="error">
                    <span class="text-1-5"><v-icon color="primary" left>mdi-alert-circle-outline</v-icon>Echec de l'envoi de votre participation</span>
                </div>

            </div>

        </v-form>
    </div>

</template>

<script>
import store from "../../store";
import axios from "axios"
import 'vue-file-agent/dist/vue-file-agent.css';
import regionsGql from "@/queries/RegionCreateEdit.graphql"
export default {
    name: "NewEventForm",

    apollo: {
        regions : regionsGql
    },

    beforeCreate() {
        if(!store.state.user) {
            window.location.replace('/mes-evenements');
        }
    },

    data: () => ({
        valid: false,
        menuDate: Array(false),
        sending : false,
        sent : false,
        error : false,
        maxSizeFileError : false,
        emptyImage : false,
        imagesProgress : 0,

        // items
        regles: [
            'Un mélange des disciplines',
            'De la convivialité',
            'Des artistes impliqué·e·s',
            'Des enfants associés',
            'Un espace de co-construction',
            'Une diversité des participant·e·s et un croisement des générations',
            'Un espace de recherche et d’expérimentation',
        ],

        // values

        // - Infos principales
        titre: '',
        organisateurs : '',
        collaboration: '',
        region: null,
        datePicker: '2024-03-20',

        // - Infos pratiques
        dates: [{date_debut : null, date_fin : null , heure : '' , lieu : '' , ville : '' , code_postal : '' , adresse : '' , latitude : null , longitude : null , lien_plus_dinfos : null}],
        publicEvent : '',

        // - Votre evenement
        imagePrincipale: [],
        reglesDuJeu: ['Un mélange des disciplines'],
        olympiade_culturelle: false,
        galerieRecords: [],
        video: '',
        investigation: '',
        aPropos: '',
        projet: '',
        contact: '',
        siteOrganisateur: '',


        // rules
        nameRules: [
            v => !!v || 'Le champ est obligatoire',
            v => (v && v.length <= 50) || 'Le champ doit contenir moins de 50 caractères',
        ],
        lengthRules: [
            v => !!v || 'Le champ est obligatoire',
            v => (v && v.length <= 200) || 'Le champ doit contenir moins de 200 caractères',
        ],
        textareaRules: [
            v => !!v || 'Le champ est obligatoire',
            v => (v && v.length <= 500) || 'Le champ doit contenir moins de 500 caractères',
        ],
        aProposRules: [
            v => !!v || 'Le champ est obligatoire',
            v => (v && v.length <= 1200) || 'Le champ doit contenir moins de 1200 caractères',
        ],
        demarchesRules: [
            v => (v.length <= 800) || 'Le champ doit contenir moins de 800 caractères',
        ],
        emailRules: [
            v => !!v || 'Le champ est obligatoire',
            v => /^[^\s@]+@[^\s@]+$/.test(v) || 'Adresse mail invalide'
        ],
        requiredRules: [
            v => !!v || 'Le champ est obligatoire',
        ],
        reglesRules: [
            v => (v && v.length >= 3) || 'Au moins trois choix doivent être sélectionnés',
            v => (v && v.includes('Un mélange des disciplines')) || 'Le mélange des disciplines est obligatoire',
        ],
    }),

    computed : {
        regionsItems() {
            if(!this.regions) return false
            let regionsItems = []
            for (let region of this.regions.nodes) {
                let itemHeader = {
                    header : region.name
                }
                regionsItems.push(itemHeader)
                for (let regionSub of region.children.nodes) {
                    let item = { text : regionSub.name , "value" : regionSub.termTaxonomyId , disabled : false}
                    regionsItems.push(item)
                }
            }

            let itemHeader = {
                header : 'Autre'
            }
            const international = {text : 'International' , value : 9, disabled : false}
            regionsItems.push(itemHeader)
            regionsItems.push(international)

            if(regionsItems.length === 0) {
                return false
            }
            return regionsItems
        },
        trueDates() {
            let dates = JSON.parse(JSON.stringify(this.dates))
            dates.forEach( (el) => {
                this.formatDate(el)
            })
            return dates
        },
        totalImages() {
            return this.imagePrincipale.length + this.galerieRecords.length
        },
        progressValue() {
            return (this.imagesProgress / this.totalImages) * 100
        },
    },

    methods: {
        changeDatePicker() {
            setTimeout( () => {
                this.datePicker = ""
            }, 10)
        },
        checkUrlField(url) {
            if(!url) return [true]
            /* eslint-disable-next-line no-useless-escape*/
            if(/https?:[0-9]*\/\/[\w!?/\+\-_~=;\.,*&@#$%\(\)\'\[\]]+/.test(url) || /http?:[0-9]*\/\/[\w!?/\+\-_~=;\.,*&@#$%\(\)\'\[\]]+/.test(url)) {
                return [true]
            }
            return ['URL non valide, elle doit commencer par https://']
        },
        affichageDate(date) {
            if(!date) return ''
            if(date.length > 1) {
                const date1 = new Date(date[0])
                const date2 = new Date(date[1])
                let dateDebut
                let dateFin
                if (date1 < date2) {
                    dateFin = date[1]
                    dateDebut = date[0]
                } else {
                    dateFin = date[0]
                    dateDebut = date[1]
                }
                const [year1, month1, day1] = dateDebut.split('-')
                dateDebut = `${day1}.${month1}.${year1}`
                const [year2, month2, day2] = dateFin.split('-')
                dateFin = `${day2}.${month2}.${year2}`
                return 'Du '+dateDebut+' au '+dateFin
            }
            const [year1, month1, day1] = date[0].split('-')
            return `${day1}.${month1}.${year1}`

        },
        addDate() {
            this.menuDate.push(false)
            this.datePicker = "2024-03-20"
            this.dates.push({date_debut : null , date_fin : null, heure : '' , lieu : '' , ville : '' , code_postal : '' , adresse : '' , latitude : null , longitude : null , lien_plus_dinfos : null})
        },
        removeDate() {
            this.menuDate.splice(-1, 1)
            this.dates.splice(-1, 1)
        },
        async formatDate (date) {
            if (!date) return null

            if(date.date_debut.length > 1) {
                const date1 = new Date(date.date_debut[0])
                const date2 = new Date(date.date_debut[1])

                if (date1 < date2) {
                    date.date_fin = date.date_debut[1]
                    date.date_debut = date.date_debut[0]
                } else {
                    date.date_fin = date.date_debut[0]
                    date.date_debut = date.date_debut[1]
                }
                const [year1, month1, day1] = date.date_debut.split('-')
                date.date_debut = `${day1}.${month1}.${year1}`
                const [year2, month2, day2] = date.date_fin.split('-')
                date.date_fin = `${day2}.${month2}.${year2}`
            } else {
                const [year, month, day] = date.date_debut[0].split('-')
                date.date_debut = `${day}.${month}.${year}`
            }
        },
        async localizePlace(date) {
            let adresse = date.adresse;
            let postal = date.code_postal;
            let ville = date.ville;
            var instance = axios.create();
            var type = "housenumber"

            if(isNaN(adresse.charAt(0))){ //If is a number
                type = 'street'
            }

            delete instance.defaults.headers.common['Authorization'];
            await instance.get(
                'https://api-adresse.data.gouv.fr/search/?q='+adresse+' '+ postal +' '+ ville +'&type='+ type +'&autocomplete=1' ,
            ).then(res => {
                date.latitude = res.data.features[0].geometry.coordinates[1];
                date.longitude = res.data.features[0].geometry.coordinates[0];
            }).catch( error => {
                console.log('api localisation' , error)
                this.sending = false
                this.error = true
            })
        },
        fileDeleted: function (fileRecord) {
            var i = this.galerieRecords.indexOf(fileRecord);
            if (i !== -1) {
                this.galerieRecords.splice(i, 1);
            }
        },
        async validate () {
            const { valid } = await this.$refs.form.validate()
            console.log('form valide ! ' , valid)
            if(this.imagePrincipale.length === 0) {
                this.emptyImage = true
                return false
            }

            this.emptyImage = false
            this.error = false

            if (this.valid && !this.sending && !this.emptyImage && this.checkFilesSizes()) await this.sendImage()
        },
        checkFilesSizes() {
            if(this.imagePrincipale[0].size >= 10000000) {
                this.maxSizeFileError = true
                return false
            }

            if(this.galerieRecords.length > 0) {
                for (const image of this.galerieRecords) {
                    if(image.size >= 10000000) {
                        this.maxSizeFileError = true
                        return false
                    }
                }
            }

            this.maxSizeFileError = false
            return true
        },
        reset () {
            this.$refs.form.reset()
        },
        resetValidation () {
            this.$refs.form.resetValidation()
        },
        async sendImage() {
            this.sending = true
            let imageID = await this.uploadImage(this.imagePrincipale)
            let galerieIDs = await this.uploadImage(this.galerieRecords)
            if(!this.error) {
                await this.createEvent(imageID , galerieIDs)
            }
        },
        async uploadImage(images) {
            let username = 'wpAppKey'
            let application_password = 'rNM7 k9MU Fak5 ENAv zQ2V 1azQ'

            let imagesIds = [];
            await Promise.all(
                images.map(async(file) => {
                    let imageData = new FormData()
                    imageData.append("file" , file.file)
                    await axios.post(store.state.baseJson+'/wp/v2/media' , imageData , {
                        headers : {
                            'Authorization': 'Basic ' + btoa(`${username}` + ":" + `${application_password}`),
                            "Content-Type": "multipart/form-data"
                        }
                    }).then( (res) => {
                        imagesIds.push(res.data.id)
                        this.imagesProgress++
                    }).catch( (error) => {
                        console.log('error push image wordpress ' , error)
                        this.sending = false
                        this.error = true
                    })
                })
            );
            if(imagesIds.length === 1) {
                return imagesIds[0]
            }
            return imagesIds
        },
        async createEvent(imageID , galerieIDs) {
            // await Promise.all(
            //     this.trueDates.map(async(date) => {
            //         await this.localizePlace(date)
            //     })
            // );
            let username = 'wpAppKey'
            let application_password = 'rNM7 k9MU Fak5 ENAv zQ2V 1azQ'

            let eventData = {
                'title' : this.titre,
                'status' : 'pending',
                'author' : store.state.user.ID,
                "terms": {"region": [this.region.text]},
                'fields' : {
                    'organisateurs' : this.organisateurs,
                    'collaboration' : this.collaboration,
                    'region' : this.region.text,
                    'dates' : this.trueDates,
                    'public' : this.publicEvent,

                    'image_principale' : imageID,
                    'regles_du_jeu' : this.reglesDuJeu,
                    'olympiade_culturelle' : this.olympiade_culturelle,
                    'url_video' : this.video,
                    'galerie' : galerieIDs,
                    'investigation' : this.investigation,
                    'a_propos' : this.aPropos,
                    'projet' : this.projet,
                    'contact' : this.contact,
                    'site_organisateur' : this.siteOrganisateur,
                }
            }
            await axios.post(store.state.baseJson+'/wp/v2/evenement' , eventData , {
                headers : {
                    'Authorization': 'Basic ' + btoa(`${username}` + ":" + `${application_password}`),
                    'content-type' : 'application/json',
                }
            }).then( () => {
                this.sending = false
                this.sent = true
                this.imagesProgress = 0
                setTimeout( () => {
                    window.location.replace('/mes-evenements');
                } , 2000)
            }).catch( (error) => {
                console.log('erreur création evenement wp' , error)
                this.sending = false
                this.error = true
            })
        },
    },
}
</script>

<style lang="scss" scoped>

</style>